declare global {

	/**
	 * `true` in every build but production (see `define` in the project.json of each frontend app, and `globals` in
	 * jest.preset.js for the specs). Guard code that production must not ship with it — the mocked or a local backend
	 * and the ways into them: the bundler substitutes the literal, so production drops the guarded code, and the lazy
	 * chunks a guarded `import()` would emit, together with the flag names in it.
	 *
	 * Reference the global itself, never a constant derived from it: the bundler only drops a branch whose condition is
	 * the literal, and a dynamic import outside such a branch still emits its chunk into dist.
	 */
	const bpNonProductionBuild: boolean;
}

/**
 * Whether the build is not production, for a runtime check in code that every frontend app bundles, including the
 * apps that don't define the global (they count as non-production). It drops no code: guard code with the global
 * itself for that.
 */
export function isNonProductionBuild(): boolean {
	return typeof bpNonProductionBuild === 'undefined' || bpNonProductionBuild;
}
